<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>市场管理</Breadcrumb-item>
        <Breadcrumb-item>AI渠道收录表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="90" :show-message="false" label-position="right">
        <Row :gutter="24">
          <Col span="6">
            <Form-item label="周期">
              <Input v-model="queryParam.period" placeholder="如 2026-10 第四周"></Input>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="姓名">
              <Input v-model="queryParam.personName" placeholder="支持模糊"></Input>
            </Form-item>
          </Col>
          <Col span="12">
            <Form-item>
              <Button type="primary" :loading="searchLoading" @click="search">查询</Button>
              <Button style="margin-left: 8px" @click="openChannelManage">渠道管理</Button>
              <Button type="primary" style="margin-left: 8px" @click="openAdd">新增</Button>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </div>
    <div style="overflow-x: auto">
      <Table :columns="columns" :data="tableDataWithSum" :loading="tableLoading" border stripe></Table>
    </div>
    <div style="margin-top: 12px; text-align: right">
      <Page :total="totalCount" :current="queryParam.pageIndex" :page-size="queryParam.pageSize"
            show-total show-sizer :page-size-opts="[50, 100, 200]"
            @on-change="onPageChange" @on-page-size-change="onPageSizeChange"></Page>
    </div>

    <Modal v-model="showModal" :title="formData.id ? '编辑' : '新增'" :width="520">
      <Form :label-width="100" ref="editForm" :model="formData">
        <Form-item label="周期" required>
          <Input v-model="formData.period" placeholder="如 2026-10 第四周"></Input>
        </Form-item>
        <Form-item label="姓名" required>
          <Input v-model="formData.personName"></Input>
        </Form-item>
        <Form-item v-for="ch in enabledChannels" :key="ch.channelKey" :label="ch.displayName">
          <Input-number v-model="formData.channelValues[ch.channelKey]" :min="0" style="width: 100%"></Input-number>
        </Form-item>
        <div v-if="!enabledChannels.length" style="color:#999;padding-left:100px">请先在渠道管理中添加渠道</div>
      </Form>
      <div slot="footer">
        <Button @click="showModal=false">取消</Button>
        <Button type="primary" :loading="saveLoading" @click="save">确定</Button>
      </div>
    </Modal>

    <Modal v-model="showChannelModal" title="渠道管理" :width="720" @on-visible-change="onChannelVisible">
      <div style="margin-bottom: 12px">
        <Button type="primary" @click="openAddChannel">新增渠道</Button>
      </div>
      <Table :columns="channelColumns" :data="allChannels" :loading="channelLoading" border stripe size="small"></Table>
      <div slot="footer">
        <Button type="primary" @click="showChannelModal=false">关闭</Button>
      </div>
    </Modal>

    <Modal v-model="showChannelEdit" :title="channelForm.id ? '改名' : '新增渠道'" :width="480">
      <Alert v-if="channelForm.id" type="info" show-icon style="margin-bottom: 12px">改名只影响展示，不影响已填数据。</Alert>
      <Form :label-width="90">
        <Form-item label="展示名" required>
          <Input v-model="channelForm.displayName" placeholder="列表列头"></Input>
        </Form-item>
        <Form-item label="标识">
          <Input v-model="channelForm.channelKey" :disabled="!!channelForm.id"
                 :placeholder="channelForm.id ? '' : '留空则自动生成'"></Input>
        </Form-item>
        <Form-item label="排序">
          <Input-number v-model="channelForm.sort" :min="0" style="width: 100%" placeholder="默认追加到末尾"></Input-number>
        </Form-item>
      </Form>
      <div slot="footer">
        <Button @click="showChannelEdit=false">取消</Button>
        <Button type="primary" :loading="channelSaving" @click="saveChannel">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import marketChannelDynamicMixin from './marketChannelDynamicMixin'

export default {
  name: 'AiChannelIncludeList',
  mixins: [marketChannelDynamicMixin],
  data () {
    return {
      bizType: 'AI_CHANNEL_INCLUDE',
      pageTitle: 'AI渠道收录表',
      listUrl: '/marketAiChannelInclude/list',
      insertUrl: '/marketAiChannelInclude/insert',
      updateUrl: '/marketAiChannelInclude/update',
      deleteUrl: '/marketAiChannelInclude/delete'
    }
  },
  methods: {
    onChannelVisible (visible) {
      if (!visible) {
        this.onChannelModalClose()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AiChannelIncludeList.vue?eff891c8